/**
 * Picks v2 or v1 of the Background Music edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import BackgroundAddEditPage   from './BackgroundAddEditPage';
import BackgroundAddEditPageV2 from './BackgroundAddEditPageV2';

export default function BackgroundAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? BackgroundAddEditPageV2 : BackgroundAddEditPage;
  return <Component {...props} />;
}
